<template>
  <ul class="m-0 list-none p-0">
    <slot />
  </ul>
</template>
